import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27ca6193"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flag-wrap d-flex align-items-center" }




export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  emits: ['update:modelValue'],
  setup(__props, { emit }) {



const setLanguage = (language: string) => {
  emit('update:modelValue', language);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "iti-flag us",
      "data-lang": "en",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setLanguage('en')))
    }),
    _createElementVNode("span", {
      class: "iti-flag de",
      "data-lang": "de",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setLanguage('de')))
    })
  ]))
}
}

})